/**
 * FireworkArtwork
 * Author: Wataru Fukushima
 * License: CC BY-ND 4.0
 */

import * as THREE from 'three'
import * as SimplexNoise from 'simplex-noise'
import { FireworkFire } from './index'

export default class FireworkStar {
  VELOCITY_THRESHOLD = 0.05
  BREAK_THRESHOLD = 0.2 // velocity 0.3
  FIRE_COUNT = 150
  velocity = 3
  vertex = {}
  geometry = null
  material = null
  mesh = null
  fire = null
  artwork = null

  constructor({ artwork }) {
    this.artwork = artwork
    this.artwork.eventBus.$on('onRender', this.render.bind(this))
    this.velocity = 3 + Math.floor(1.1 * Math.random())
    const x = (window.innerWidth / 2) * (Math.random() - 0.5)
    const y = 0
    // const z = 150 * (Math.random() - 0.5)
    const z = 450 * Math.random() - 450
    this.vertex = new THREE.Vector3(x, y, z)
    this.geometry = new THREE.Geometry()
    this.geometry.vertices = [this.vertex]
    this.material = new THREE.PointsMaterial({
      size: 3,
      color: 'rgb(250, 130, 120)',
      // color: 'rgb(239, 189, 129)',
      opacity: 1,
      transparent: true
    })
    this.mesh = new THREE.Points(this.geometry, this.material)
  }

  // 散開
  break() {
    this.fire = new FireworkFire({
      artwork: this.artwork,
      x: this.vertex.x,
      y: this.vertex.y,
      z: this.vertex.z,
      count: this.FIRE_COUNT
    })
    this.artwork.scene.add(this.fire.mesh)
    this.destroy()
  }

  decalerate(value) {
    return value > this.VELOCITY_THRESHOLD ? value * 0.99 : 0
  }

  move() {
    if (!this.simplex) this.simplex = new SimplexNoise()
    const noise = this.simplex.noise3D(this.vertex.x, this.vertex.y, this.vertex.z)
    this.vertex.x += noise * 0.5
    this.velocity = this.decalerate(this.velocity)
    this.vertex.y += 1 * this.velocity
    this.mesh.geometry.vertices = [this.vertex]
    this.mesh.geometry.verticesNeedUpdate = true
  }

  render() {
    //* 花火玉のアニメーション
    this.move()

    //* 火のアニメーション
    if (!this.fire && this.velocity <= this.BREAK_THRESHOLD) this.break()
  }

  // eslint-disable-next-line no-unused-vars
  destroyInstance(instance) {
    instance = null
  }

  destroy() {
    this.artwork.scene.remove(this.mesh)
    this.geometry.dispose()
    this.material.dispose()
    this.artwork.eventBus.$emit('destroyInstance', this)
    this.simplex = null
  }
}
